import { Map as ImmutableMap } from 'immutable';
import { createSelector } from 'reselect';

import { selectAlarmCategories, selectAlarmDefinitions } from '@sophocles/features/reference';

export const alarmStateSelector = state => state.entities.alarmStates;

/*
 {
 id:int,
 timestamp: time,
 site:int,
 alarm: {
 category: int,
 display_name: string,
 relay: string
 }
 }
 */

// id-keyed lookup of the joined alarm-definition + category fields the legacy
// Immutable readers below actually consume (structuresSelectors.js,
// structureSelectors.js, structureMapSelectors.js): the alarm's category id,
// the category's display name (the alarm badge groups by category, not by
// individual alarm), and a relay slot that's never resolved from the catalog.
const getAlarmDefinitionsById = createSelector(
  selectAlarmDefinitions,
  selectAlarmCategories,
  (definitions, categories) => {
    const categoriesById = new Map(categories.map(category => [String(category.id), category]));
    return new Map(
      definitions.map(definition => {
        const category = categoriesById.get(String(definition.category_id));
        return [
          String(definition.id),
          ImmutableMap({
            category: definition.category_id,
            display_name: category?.display_name || 'No name',
            relay: '',
          }),
        ];
      }),
    );
  },
);

export const getFilledAlarmStates = createSelector(
  alarmStateSelector,
  getAlarmDefinitionsById,
  (alarmStates, alarmsById) =>
    alarmStates.map(alarmState => alarmState.set('alarm', alarmsById.get(alarmState.get('alarm').toString()))),
);
